import React from 'react';
import PropTypes from 'prop-types';
import { MdClose } from 'react-icons/md';

/**
 * `.bulk-bar` from the entity-list spec — accent-filled banner shown above the
 * table head (inside `DataTable`'s `selection.bulkBar` slot) once at least one
 * row is selected. Actions are passed in so each list can wire its own bulk
 * operations; this component only owns layout/chrome.
 */
function BulkBar({ count, label, actions, onClear }) {
	return (
		<div className='tw:flex tw:items-center tw:gap-3 tw:px-4 tw:py-2.5 tw:bg-accent tw:text-white'>
			<span className='tw:text-[13px] tw:font-medium'>
				{count} {label}
			</span>
			<div className='tw:ml-auto tw:flex tw:items-center tw:gap-2'>
				{actions}
				<button
					type='button'
					onClick={onClear}
					aria-label='Limpiar selección'
					className='tw:inline-grid tw:place-items-center tw:w-7 tw:h-7 tw:rounded-[7px] tw:border-0 tw:bg-transparent tw:text-white tw:hover:bg-white/20'
				>
					<MdClose />
				</button>
			</div>
		</div>
	);
}

BulkBar.propTypes = {
	count: PropTypes.number.isRequired,
	label: PropTypes.string.isRequired,
	actions: PropTypes.node,
	onClear: PropTypes.func.isRequired,
};

export default BulkBar;
